export enum UserPathsEnum {
  MY_BOOKINGS = "/my-bookings",
}
